import {MechanicValidator} from './MechanicValidator'
import {ActionStatus, PieceTypes} from '@colonist/game-base-types'
import {MechanicCityWallPlayerState, MechanicCityWallState, NestedReadonly, PlayerColor, TileCornerBonusType, TileCornerBuildingType} from '@colonist/game-states'
import {PlayerValidator} from '@colonist/game-mechanic-validators'
import {MapValidator} from '../core/map/MapValidator'
import {getCardsForPiece} from '@colonist/game-card-types'

export class MechanicValidatorCityWall extends MechanicValidator {
    private readonly cityWallState: MechanicCityWallState

    constructor(playerStates: PlayerValidator[], mapState: MapValidator, cityWallState: MechanicCityWallState) {
        super(playerStates, mapState)

        this.cityWallState = cityWallState
    }

    getCityWallPlayerState(player: PlayerColor): NestedReadonly<MechanicCityWallPlayerState> {
        if(player == PlayerColor.None) {
            return {
                bankCityWallAmount: 0,
            }
        }
        const cityWallPlayerState = this.cityWallState[player]
        if(cityWallPlayerState === undefined) throw new Error(`No MechanicCityWallPlayerState for player ${player}`)

        return cityWallPlayerState
    }

    hasResourcesAndPiecesForCityWall(player: PlayerColor, useResource: boolean): ActionStatus {
        const cityWallPlayerState = this.getCityWallPlayerState(player)
        if(cityWallPlayerState.bankCityWallAmount <= 0) return {canTakeAction: false, errorMessageIfCantTakeAction: {key: 'strings:game.errors.notEnoughCityWallPieces'}}
        if(!useResource) return {canTakeAction: true}

        const playerController = this.playerValidators.get(player)
        if(playerController === undefined) return {canTakeAction: false, errorMessageIfCantTakeAction: {key: 'strings:game.errors.noPlayer'}}

        const resourcesForCityWall = getCardsForPiece(PieceTypes.CityWall)
        const hasResourcesForCityWall = playerController.hasResourceCardsInHand(resourcesForCityWall)
        if(!hasResourcesForCityWall) return {canTakeAction: false, errorMessageIfCantTakeAction: {key: 'strings:game.errors.notEnoughResources'}}

        return {canTakeAction: true}
    }

    canPlayerPlaceCityWall(player: PlayerColor): ActionStatus {
        const where = this.whereCanPlayerPlaceCityWall(player)

        const useResources = true
        const doesPlayerHaveResourcesAndPiecesForCityWall = this.hasResourcesAndPiecesForCityWall(player, useResources)
        doesPlayerHaveResourcesAndPiecesForCityWall.validHoverLocations = where
        if(!doesPlayerHaveResourcesAndPiecesForCityWall.canTakeAction) return doesPlayerHaveResourcesAndPiecesForCityWall

        if(where.length <= 0) return {canTakeAction: false, errorMessageIfCantTakeAction: {key: 'strings:game.errors.noFreeCity'}, validHoverLocations: where}

        return {canTakeAction: true, validHoverLocations: where}
    }

    whereCanPlayerPlaceCityWall(player: PlayerColor): number[] {
        const placesToBuildCityWallArray: number[] = []
        for(const [index, corner] of this.mapValidator.tileState.tileCorners.entries()) {
            if(corner.owner != player) continue
            if(corner.buildingType != TileCornerBuildingType.City) continue
            if(corner.hasCornerBonusOfType(TileCornerBonusType.CityWall)) continue

            placesToBuildCityWallArray.push(index)
        }
        return placesToBuildCityWallArray
    }
}
